let API_BASE = process.env.REACT_APP_API_URL || "https://essencebackend-43f3.onrender.com";
if (!API_BASE.endsWith("/api")) {
  API_BASE += "/api";
}

export const useClients = () => {
  const getClients = async () => {
    try {
      const res = await fetch(`${API_BASE}/clients`);
      if (!res.ok) throw new Error("Failed to fetch clients");
      const data = await res.json();
      const items = data.map(client => ({
        sys: { id: client._id },
        fields: {
          clientname: client.name,
          photos: [{ fields: { file: { url: client.logoUrl } } }]
        }
      }));
      return { items };
    } catch (err) {
      console.error(err);
      return { items: [] };
    }
  };
  return { getClients };
};

export const useProjects = () => {
  const getProjects = async () => {
    try {
      const res = await fetch(`${API_BASE}/projects`);
      if (!res.ok) throw new Error("Failed to fetch projects");
      const data = await res.json();
      const items = data.map(p => ({
        sys: { id: p._id },
        fields: {
          title: p.title,
          categoryName: { fields: { name: p.category?.name || 'General' } },
          outerbanner: { fields: { file: { url: p.bannerPhoto || p.imageUrls?.[0] || '' } } },
          banner: { fields: { file: { url: p.bannerPhoto || p.imageUrls?.[0] || '' } } },
          description: p.description,
          clientName: p.clientName || p.client?.name || '',
          services: p.services || '',
          industry: p.industry || '',
        }
      }));
      return { items };
    } catch (err) {
      console.error(err);
      return { items: [] };
    }
  };
  return { getProjects };
};

export const useProject = () => {
  const getProject = async (id) => {
    try {
      const res = await fetch(`${API_BASE}/projects/${id}`);
      if (!res.ok) throw new Error("Failed to fetch project");
      const p = await res.json();
      
      const gallery = (p.gallery && p.gallery.length > 0) ? p.gallery : (p.imageUrls || []);
      
      return {
        sys: { id: p._id },
        fields: {
          title: p.title,
          categoryName: { fields: { name: p.category?.name || 'General' } },
          outerbanner: { fields: { file: { url: p.bannerPhoto || p.imageUrls?.[0] || '' } } },
          bannerPhoto: { fields: { file: { url: p.bannerPhoto || p.imageUrls?.[0] || '' } } },
          miniPhoto: { fields: { file: { url: p.miniPhoto || p.imageUrls?.[0] || '' } } },
          description: p.description,
          clientName: p.clientName || p.client?.name || '',
          services: p.services || '',
          industry: p.industry || '',
          projectBrief: p.projectBrief || p.description,
          solutionBrief: p.solutionBrief || '',
          projectLink: p.projectLink || '',
          quotePhoto: { fields: { file: { url: p.quotePhoto || '' } } },
          quoteDescription: p.quoteDescription || '',
          quoteTitle: p.quoteTitle || '',
          gallery: gallery.map((imgUrl, i) => ({
            fields: { description: `Gallery ${i}`, file: { url: imgUrl } }
          }))
        }
      };
    } catch (err) {
      console.error(err);
      return null;
    }
  };
  return { getProject };
};

export const useCategories = () => {
  const getCategories = async () => {
    try {
      const res = await fetch(`${API_BASE}/categories`);
      if (!res.ok) throw new Error("Failed to fetch categories");
      const data = await res.json();
      const items = data.map(c => ({
        sys: { id: c._id },
        fields: {
          name: c.name
        }
      }));
      return { items };
    } catch (err) {
      console.error(err);
      return { items: [] };
    }
  };
  return { getCategories };
};

export const useTestimonials = () => {
  const getTestimonials = async () => {
    try {
      const res = await fetch(`${API_BASE}/testimonials`);
      if (!res.ok) throw new Error("Failed to fetch testimonials");
      const data = await res.json();
      const items = data.map(t => ({
        sys: { id: t._id },
        fields: {
          description: t.quote,
          clientname: t.authorName,
          jobtitle: t.company,
          clientphoto: { fields: { file: { url: t.avatarUrl } } }
        }
      }));
      return { items };
    } catch (err) {
      console.error(err);
      return { items: [] };
    }
  };
  return { getTestimonials };
};

export const useTeams = () => {
  const getTeams = async () => {
    try {
      const res = await fetch(`${API_BASE}/team`);
      if (!res.ok) throw new Error("Failed to fetch team members");
      const data = await res.json();
      const items = data.map(t => ({
        sys: { id: t._id },
        fields: {
          name: t.name,
          jobTitle: t.role,
          jobDescription: t.bio,
          teamimage: { fields: { description: t.name, file: { url: t.avatarUrl } } }
        }
      }));
      return { items };
    } catch (err) {
      console.error(err);
      return { items: [] };
    }
  };
  return { getTeams };
};
